import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class ForecastsPopupsCorrelationFailureComponent extends PopupInnerContextComponent<PopupData.Forecast.CorrelationFailure> {
	@action
	handleOk(): void {
		this.popupData.onOk();
		this.close();
	}
	<template>
		<div class="popup-type-correlation-failure">
			<p class="popup-type-correlation-failure__message">
				Not enough data available to calculate correlation factor automatically. It was set
				to 0.5. Please adjust manually!
			</p>
			<SubmitButtonComponent
				@text="OK"
				@extraClass="popup-type-correlation-failure__button"
				@onTrigger={{this.handleOk}}
			/>
		</div>
	</template>
}
